import {Component} from '@angular/core';
import {Handler} from '../../../common/handler';
import {ChartDataPerMeasurement} from '../../../utils/chart-data-provider';
import {CompassRecord, EntityEnergyCompassComponent} from './entity-energy-compass.component';
import lodash from 'lodash';
import moment from "moment/moment";
import {RefdataUtils} from "../../refdata/refdata-utils";
import {EnergyCompassUtils} from "../../charts/energy-compass-chart/energy-compass.utils";
import {DataType} from "@flowmaps-com/flowmaps-typescriptmodels";
import {Entity} from "../../../handlers/entity";

@Component({
    selector: 'app-meter-energy-compass',
    templateUrl: './entity-energy-compass.component.html',
    styleUrls: ['entity-energy-compass.component.scss']
})
@Handler()
export class MeterEnergyCompassComponent extends EntityEnergyCompassComponent {

    override get noDataText(): string {
        if (!this.meters || this.meters.length === 0) {
            return 'No meter selected';
        }
        const totalArea = this.getTotalArea();
        if (!totalArea) {
            return 'No area defined for selected meters, consumption per m² is unavailable';
        }
        if (this.values.length === 0) {
            return 'No electricity consumption data available for this meter';
        }
        return '';
    }

    override computeValues = (d: ChartDataPerMeasurement): CompassRecord[] => {
        const totalArea = this.getTotalArea();
        if (!totalArea || !d?.totalsPerYear) return [];
        const values = Object.entries(d.totalsPerYear.measurements)
            .flatMap(([type, points]) =>
                points.map(dp => ({
                    timeRange: dp.timeRange,
                    value: dp.value,
                    measurementType: type as DataType
                }))
            );
        return Object.entries(lodash.groupBy(values, v => v.timeRange.start))
            .map(([start, group]) => ({
                year: moment(start).year(),
                value: lodash.round(
                    lodash.sum(group.map(v =>
                        EnergyCompassUtils.getMeterValueWithFactor(v.measurementType, [v.value])
                    )) / totalArea,
                    1
                )
            }))
            .sort(RefdataUtils.locationEnergyCompassYearsComparator.compare);
    }

    private getTotalArea(): number {
        if (!this.meters?.length) return 0;
        if (this.hasInvalidArea(this.meters)) {
            return 0;
        }
        return lodash.sum(
            this.meters.map(m => RefdataUtils.getMeterArea(m.meter))
        );
    }

    private hasInvalidArea(meters: Entity[]): boolean {
        return meters.some(m => {
            const area = RefdataUtils.getMeterArea(m.meter);
            return typeof area !== 'number' || area <= 0;
        });
    }

}
